import { type MyLensesOrganization } from "../../../gql-generated/types";

type OrganizationNameId = Pick<MyLensesOrganization, "name" | "id">;
export const sortOrganizationsAvailableForLensSpaceCreation = <TOrganization extends OrganizationNameId>(
    organizations: readonly TOrganization[],
    defaultOrganizationId: string,
): readonly TOrganization[] => {
    const orgs = [...organizations];
    const sortedOrganizations = orgs.sort((a, b) => {
        if (a.id === defaultOrganizationId) {
            return -1;
        }
        if (b.id === defaultOrganizationId) {
            return 1;
        }

        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    return sortedOrganizations;
};
